import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";
import { Form, LevelsAutocomplete } from "@shared/components";
import { AgreementsAutocomplete, BookCategoriesAutocomplete } from "@shared/components/AutocompleteFields";
import {
  useDateOptions,
  useMediaTypeOptions,
} from "@shared/options";
import { useListSectorsQuery } from "@modules/bookSectors/services/queries";

//TODO need to fix the level field
export const BookListFilters = React.memo(() => {
  const translate = useTranslate();
  const { getMonthOptions, getYearOptions } = useDateOptions();
  const { getMediaTypeOptions } = useMediaTypeOptions();
  const { data: sectors = [] } = useListSectorsQuery({ perPage: 100 });

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label="Buscar por Título ou ISBN"
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="sector"
          label={translate("book_category_admin.fields.sector")}
          options={[
            { value: "", label: translate("options.none") },
            ...sectors.map((sector) => ({
              label: sector.name,
              value: sector.id,
            })),
          ]}
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <BookCategoriesAutocomplete
          name="categories"
          label={translate("v1/book_admin.fields.categories")}
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="month_featured"
          label={translate("v1/book_admin.filters.month")}
          options={getMonthOptions()}
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 6 }}>
        <Form.Select
          name="month_featured_year"
          label={translate("v1/book_admin.filters.year")}
          options={getYearOptions()}
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="type"
          label={translate("v1/book_admin.filters.type")}
          options={getMediaTypeOptions()}
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="is_best_seller"
          label="Best Seller"
          options={[
            { value: "", label: translate("options.none") },
            { label: "Sim", value: "true" },
            { label: "Não", value: "false" },
          ]}
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="origin"
          label="Origem"
          options={[
            { value: "", label: translate("options.none") },
            { label: "Bookwire", value: "bookwire" },
            { label: "Globo", value: "globo" },
            { label: "Partiu", value: "partiu" },
          ]}
          fullWidth
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <AgreementsAutocomplete
          name="agreement_id"
          label={translate("v1/book_admin.fields.agreement_name")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <LevelsAutocomplete
          name="levels_rank"
          label={translate("v1/book_admin.filters.level")}
        />
      </Grid>
    </Grid>
  );
});
